import { getReviewStatesSuccess } from "../actions/songactions";
import { call, put } from "redux-saga/effects";
import { getReviewStates } from "../api/GetReviewStatesCall";
import { reportError } from "../actions/erroractions";

export function* getReviewStatesSaga() {
    try {
        const result = yield call(getReviewStates);

        if (result.ok) {
            yield put(getReviewStatesSuccess(result.reviewStates))
        } else {
            yield put(reportError("Unable to retrieve review states"));
        }

    } catch(e) {
        yield put(reportError("Unable to retrieve review states"));
    }
}